import { useState } from 'react';

import { menuBarV2ContentConst } from 'constants/common/menu/menuBarContentConst';

const useMenuBar = () => {
  const [subContent, setSubContent] = useState({
    isOpen: false,
    title: '',
    items: [],
  });

  const onMenuBarOpen = (item) => {
    setSubContent({
      isOpen: true,
      title: item.title,
      items: menuBarV2ContentConst[item.title],
    });
  };

  const onMenuBarClose = () => {
    setSubContent({
      isOpen: false,
      items: [],
    });
  };

  return {
    subContent,
    onMenuBarOpen,
    onMenuBarClose,
  };
};

export default useMenuBar;
